<mat-card class="cl-device-section">
    <mat-card-title>
        <span class="cl-section-header" [ngClass]="headerClass">{{deviceInput.displayText}}</span>
    </mat-card-title>

    <mat-card-content>
        <rr-weekly-scheduler [adapter]="adapter"
                             *ngIf="isReady"
                             [options]="weeklySchedulerOptions">
        </rr-weekly-scheduler>
    </mat-card-content>

</mat-card>